var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDpcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 23,
    r: 23,
    fill: "#E8FFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9331 34.9984V27.8463C42.9331 25.2816 40.9731 22.4458 38.5751 21.5491L28.1702 17.6499C26.4395 17.0035 23.6037 17.0035 21.873 17.6499L11.4681 21.57C9.07015 22.4666 7.11011 25.3024 7.11011 27.8463V43.339C7.11011 45.7995 8.73653 49.0315 10.7174 50.512L19.6836 57.2053C21.1432 58.3313 23.0824 58.8735 25.0216 58.8735",
    stroke: "#00B894",
    strokeWidth: 3.75328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3626 54.7031C37.969 54.7031 41.7032 50.9689 41.7032 46.3625C41.7032 41.7561 37.969 38.0219 33.3626 38.0219C28.7562 38.0219 25.022 41.7561 25.022 46.3625C25.022 50.9689 28.7562 54.7031 33.3626 54.7031Z",
    stroke: "#00B894",
    strokeWidth: 3.75328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7788 56.7883H43.7976",
    stroke: "#00B894",
    strokeWidth: 3.75328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpcLogo);
export default __webpack_public_path__ + "static/media/dpc-logo.54bba1e17d36596bc09772dbef351d19.svg";
export { ForwardRef as ReactComponent };